import React, {useState} from 'react'
// import dynamic from "next/dynamic";
import SnapDraggableShapesTransformer from "./snap-draggable-shapes-transformer";
import LinePointsAnchor from "./line-points-anchor";
import DraggableText from "./draggable-text";
import KonvaReference from './konva-reference';
import ShapeTransformer from "./shape-transformer";
import DragDropImage from "./drag-drop-image";
import SnapImageTransformer from "./snap-image-transformer";
import ImageTransformer from "./image-transformer";
import SnapGridTransformer from "./snap-grid";

/*const DraggableTextComponent = dynamic(() => import("./draggable-text"), {
    ssr: false,
});

const KonvaReferenceComponent = dynamic(() => import("./konva-reference"), {
    ssr: false,
});

const ShapeTransformerComponent = dynamic(() => import("./shape-transformer"), {
    ssr: false,
});

const ImageTransformerComponent = dynamic(() => import("./image-transformer"), {
    ssr: false,
});

const SnapDraggableShapesTransformerComponent = dynamic(() => import("./snap-draggable-shapes-transformer"), {
    ssr: false,
});

const SnapImageTransformerComponent = dynamic(() => import("./snap-image-transformer"), {
    ssr: false,
});

const SnapGridTransformerComponent = dynamic(() => import("./snap-grid"), {
    ssr: false,
});

const LinePointsAnchorComponent = dynamic(() => import("./line-points-anchor"), {
    ssr: false,
});

const DragDropImageComponent = dynamic(() => import("./drag-drop-image"), {
    ssr: false,
});*/

const examples = [
    /*    {
            name: 'Line Points Anchor',
            key: 'LinePointsAnchor'
        },*/
    {
        name: 'Drag Drop Image',
        key: 'DragDropImage'
    },
    {
        name: 'Snap Grid Transformer',
        key: 'SnapGridTransformer'
    },
    {
        name: 'Snap Image Transformer',
        key: 'SnapImageTransformer'
    },
    {
        name: 'Snap Draggable Shapes Transformer',
        key: 'SnapDraggableShapesTransformer'
    },
    {
        name: 'Draggable Text',
        key: 'DraggableText'
    },
    {
        name: 'Konva Reference',
        key: 'KonvaReference'
    },
    {
        name: 'Shape Transformer',
        key: 'ShapeTransformer'
    },
    {
        name: 'Image Transformer',
        key: 'ImageTransformer'
    },
]

const KonvaEditor = () => {
    const [selectedExample, setSelectableExample] = useState(examples[0]);

    return (
        <>
            <div className="m-8">
                <div className="flex justify-center items-center my-auto">
                    {examples?.map((exampleItem, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                setSelectableExample(exampleItem)
                            }}
                            className={`konva-example-tab ${exampleItem.key === selectedExample.key ? 'konva-example-tab-selected' : ''}`}>
                            <div className="mx-4 my-2">{exampleItem.name}</div>
                        </button>
                    ))}
                </div>
            </div>

            <div className="flex justify-center mt-8">
                <div className="justify-center h-3/4 w-3/4 m-8 bg-white">
                    {selectedExample.key === 'DraggableText' &&
                        <DraggableText/>
                    }

                    {selectedExample.key === 'KonvaReference' &&
                        <KonvaReference/>
                    }

                    {selectedExample.key === 'ShapeTransformer' &&
                        <ShapeTransformer/>
                    }

                    {selectedExample.key === 'ImageTransformer' &&
                        <ImageTransformer/>
                    }

                    {selectedExample.key === 'SnapDraggableShapesTransformer' &&
                        <SnapDraggableShapesTransformer/>
                    }

                    {selectedExample.key === 'SnapImageTransformer' &&
                        <SnapImageTransformer/>
                    }

                    {selectedExample.key === 'SnapGridTransformer' &&
                        <SnapGridTransformer/>
                    }

                    {selectedExample.key === 'LinePointsAnchor' &&
                        <LinePointsAnchor/>
                    }

                    {selectedExample.key === 'DragDropImage' &&
                        <DragDropImage/>
                    }

                </div>
            </div>

        </>
    );
}

export default KonvaEditor
